import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ApuStandardResourceActions } from "./apu-standard-resource.actions";
import { ApuStandardResourceService } from "@/core/services/apu-standard-resource.service";
import { ApuStandardResourceApiModel } from "@/core/models/api/apu-standard-resource-api.model";

@Injectable()
export class ApuStandardResourceEffects {
    actions$ = inject(Actions);
    apuStandardResourceService = inject(ApuStandardResourceService);

    constructor(){

    }

    _loadApuStandardResource = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardResourceActions.loadApuStandardResources),
            exhaustMap(() => {
                return this.apuStandardResourceService.getAll().pipe(
                    map((response: any) => {
                        const apuStandardResources = response as ApuStandardResourceApiModel[];
                        return ApuStandardResourceActions.loadApuStandardResourceSuccess({ apuStandardResources });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _addRange = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardResourceActions.addRangeApuStandardResources),
            exhaustMap((action) => {
                return this.apuStandardResourceService.addRange(action.apuStandardResourceList).pipe(
                    map((response: any) => {
                        const apuStandardResourceList = response as ApuStandardResourceApiModel[];
                        return ApuStandardResourceActions.addRangeApuStandardResourceSuccess({ apuStandardResourceList });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _delete = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardResourceActions.deleteApuStandardResource),
            exhaustMap((action) => {
                return this.apuStandardResourceService.delete(action.apuStandardResourceId).pipe(
                    map((response: any) => {
                        console.log('RESPONSE: ', response);
                        return ApuStandardResourceActions.deleteApuStandardResourceSuccess({ apuStandardResourceId: action.apuStandardResourceId });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}